module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-YOUTUBEPLAY.967319ed.png";